import React, { Component } from "react";
import RegisterModal from "../../../components/RegisterModal/RegisterModal";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : RegisterModalForm
Description : Compoente que alberga el resto del formulario de registro definido en el directorio de componentes
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se llama al componente de RegisterModal con sus respectivos parámetros.
================================================================================ */

class RegisterModalForm extends Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <RegisterModal email={this.props.email}/>
        )
    }
}

export default RegisterModalForm;